import React, { useEffect, useState } from 'react';
import { Typography } from 'antd';
import { getMasterFranchiseConfigurations } from '@/services/MasterFranchiseConfigurationService';
import useLocalStorage from '@/hooks/useLocalStorage';
import getCurrencyRate from '@/services/CurrencyExchangeService';
import ECurrency from '@/enums/ECurrency';

const LOCAL_STORAGE_KEY = 'currency_exchange_usd_mxn';

const CurrencyExchangeDisplay: React.FC = () => {
  const [rate, setRate] = useLocalStorage({ key: LOCAL_STORAGE_KEY });
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    getMasterFranchiseConfigurations({ masterFranchiseId: 1 })
      .then((configs) => {
        const token = configs.find(c => c.key === 'mexican_bank_token')?.value;
        if (!token) {
          setVisible(false);
          return;
        }
        setVisible(true);
        return getCurrencyRate({ from: ECurrency.USD, to: ECurrency.MXN });
      })
      .then((exchange) => {
        if (!exchange) return;
        setRate(exchange.rate);
      })
      .catch(() => {
        // Si el servicio falla, se mantiene el valor guardado en localStorage
        setVisible(rate != null);
      });
  }, []);

  if (!visible || rate == null) return null;

  return (
    <Typography.Text>
      {'USD '}
      <Typography.Text strong>
        {`$${Number(rate).toFixed(2)} MXN`}
      </Typography.Text>
    </Typography.Text>
  );
};

export default CurrencyExchangeDisplay;
